import { connect } from 'react-redux';

import DataForm from './DataForm.js';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedDataForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(DataForm);

export default ConnectedDataForm;
